import React from 'react';
import Modal from '../../component/Inc/Modal';
function PopClassRequest(props) {
  const {open, close} = props;
  return (
    <Modal open={open} close={close} type="pop_class_request" popSize="s">
      <h2 className="pop_tit">배정 요청서</h2>
      <div className="content_container scroll">
        <div className="com_board_box">
          <div className="board_item">
            <div className="info">
              <p className="cont bold">요청 수업</p>
            </div>
            <div className="info">
              <span className="tit">학생명</span>
              <p className="cont com_blue_txt">
                <b>김학생</b>(고3이상)
              </p>
            </div>
            <div className="info">
              <span className="tit">수업 과목</span>
              <p className="cont com_blue_txt">과탐(사회문화, 경제, 밥과정서)</p>
            </div>
            <hr className="com_divider" />
            <div className="info">
              <span className="tit">타임</span>
              <p className="cont">2T</p>
            </div>
            <div className="info">
              <span className="tit">수업일</span>
              <p className="cont">월, 화 ㅣ 12 : 30</p>
            </div>
            <div className="info">
              <span className="tit">완성수업</span>
              <p className="cont"></p>
            </div>
            <div className="info">
              <span className="tit">수업 시간 / 방법</span>
              <p className="cont">30분 / 대면</p>
            </div>
            <div className="info">
              <span className="tit">비교수업</span>
              <p className="cont">N</p>
            </div>
            <div className="info">
              <span className="tit">동시수업</span>
              <p className="cont">김학생103, 최학생123, 최학생105,</p>
            </div>
            <hr className="com_divider" />
            <div className="info">
              <span className="tit">첫 수업일</span>
              <p className="cont com_blue_txt">2023, 05, 12 ㅣ 12 : 30</p>
            </div>
            <div className="info">
              <span className="tit">수업지역</span>
              <p className="cont com_blue_txt">경기도 성남시 분당구 백형동 3214-345</p>
            </div>
          </div>
        </div>
        <div className="com_board_box">
          <div className="com_info center">
            <p className="name">요청일 : 2024, 05, 12 ㅣ 12 : 30</p>
          </div>
          <div className="com_info center light_orange">
            <div className="com_radio_wrap">
              <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
              <label htmlFor="rdo01">수업 승인</label>
              <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
              <label htmlFor="rdo02">수업불가</label>
            </div>
          </div>
        </div>
        <div className="com_red_txt">
          ※ 본 요청서 확인 후 10일 이내 회신이 없을 경우 수업불가 의사로 간주하고 ERP 계정 삭제 등 계약 종료를 진행합니다.
          <br />
          ※ 계약 종료 후 재입사하시는 경우 신규강사 교육 등 강사 계약 절차를 다시 진행합니다.
          <br />※ 계약 종료 시 기존 시수 및 포인트는 초기화되는 점 알려드립니다.
        </div>
      </div>
    </Modal>
  );
}

export default PopClassRequest;
